import React, { useState } from "react";
import { CreateProductType } from "../../types";
import { useUploader } from "../../../../../hooks/Upload";
import { message, Space } from "antd";
import Loader from "Components/Loader";
import Dragger from "antd/es/upload/Dragger";
import EditSubmitButton from "./EditSubmitButton";
import { useUploadHelper } from "../../AddNewProduct/Components/useUploadHelper";

type UploadImageFormProps = {
  setActive: React.Dispatch<React.SetStateAction<number>>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  payload: CreateProductType;
  setPayload: React.Dispatch<React.SetStateAction<CreateProductType>>;
  edit: boolean;
  handleSubmit: any;
  validity: any;
  isLoading: any;
  active: number;
};

const EditUploadImageForm: React.FC<UploadImageFormProps> = ({
  setActive,
  active,
  handleInputChange,
  payload,
  setPayload,
  edit,
  handleSubmit,
  validity,
  isLoading,
}) => {
  const { mutateAsync, isPending } = useUploadHelper({ payload, setPayload });
  const [images, setImages] = useState<string>("");

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = async () => {
        const imageBase64 = reader.result as string;
        setImages(imageBase64);

        try {
          await mutateAsync(imageBase64);
        } catch (error) {
          console.error("Image upload failed:", error);
          message.error("Error uploading file");
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files) return;
    const filesArray = Array.from(event.target.files);

    if (payload.images.length + filesArray.length > 5) {
      message.error("You can only upload up to 5 images");
      return;
    }

    // setSelectedFiles((prev) => [...prev, ...filesArray]);

    for (const file of filesArray) {
      try {
        await mutateAsync(file);
      } catch (error) {
        console.error("Upload error:", error);
      }
    }
  };

  const handleRemoveImage = (index: number) => {
    const updatedImages = payload.images.filter((_, i) => i !== index);
    setPayload((prev) => ({ ...prev, images: updatedImages }));
  };
  return (
    <div className="mx-auto max-w-[403px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px] px-[20px] py-[30px]">
      <h3 className="text-black mb-[13px] font-medium">Upload Product Image</h3>
      <p className="text-[#afafaf] mb-3">
        Select and upload multiple product images
      </p>
      <div className="relative">
        <div className="py-[20px] mb-[30px] bg-[#f0f0f0] rounded-md">
          <label className="cursor-pointer">
            <FileIcon />
            <p className="text-center mt-[18px]">
              Drag and drop or <span className="text-orange">browse file</span>{" "}
              to upload
            </p>
            <div className="text-center text-[#a5a5a5]">
              Max file size: 3000 by 3000 px, 20MB
            </div>
            <input
              type="file"
              id="upload"
              multiple
              accept="image/*"
              hidden
              onChange={handleFileChange}
              disabled={payload.images.length >= 5}
            />
          </label>
        </div>

        <div className="grid grid-cols-3 gap-4 pb-2">
          {payload.images.map((image, index) => (
            <div key={index} className="relative">
              <img
                src={image}
                alt={`Uploaded ${index}`}
                className="w-full h-32 object-cover border-[1px] border-[#ddd] rounded-md p-2"
              />
              <button
                onClick={() => handleRemoveImage(index)}
                className="absolute top-1 right-1 bg-[#000000a8] text-white p-1 rounded-full text-xs"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </button>
            </div>
          ))}
        </div>

        {isPending && (
          <div className="w-full h-full absolute top-0 left-0 flex items-center justify-center">
            <Loader />
          </div>
        )}
      </div>
      <EditSubmitButton
        handleSubmit={handleSubmit}
        validity={validity}
        isLoading={isLoading}
      />

      <div className="flex gap-x-3 mt-3">
        <button
          disabled={isLoading}
          className="text-orange bg-primary-light p-[16px] w-full font-bold rounded-md ease-in-out duration-300"
          onClick={() => setActive(active - 1)}
        >
          Previous
        </button>
        <button
          disabled={isLoading}
          className="text-orange bg-primary-light p-[16px] w-full font-bold rounded-md ease-in-out duration-300"
          onClick={() => setActive(active + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default EditUploadImageForm;

const FileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-12 mx-auto text-[#9d9d9d]"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
);
